/*! @azure/msal-common v15.4.0 2025-03-25 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.4.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
